import classNames from 'classnames'
import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ApprenticeBody } from '../../../../../model/person.model'
import { Profession } from '../../../../../model/profession.model'
import { useAppSelector } from '../../../../../redux/hooks'

interface ProfOptions {
  value: number
  label: string
  specialities: SpecOptions[]
}

interface SpecOptions {
  value: number
  label: string
}

export const ProfessionDropdown = () => {
  const {
    control,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useFormContext<ApprenticeBody>()

  const { loadedBasicInformation } = useAppSelector((state) => state.user)
  const professions = useAppSelector((state) => state.professions)
  const [selectedProf, setSelectedProf] = useState<ProfOptions>()
  const [professionOptions, setProfessionOptions] = useState([])

  // todo not translated
  useEffect(() => {
    if (!loadedBasicInformation) {
      return
    }
    const activeLanguage = localStorage.getItem('i18nextLng')

    const profId = getValues('id_profession')
    const profs: ProfOptions[] = []

    professions?.map((p: Profession) => {
      const po = {
        label:
          activeLanguage === 'de'
            ? p.profession
            : t(`profession.${p.profession_id}`),
        value: p.profession_id,
        specialities: p.specialities?.map((s) => {
          return {
            label:
              activeLanguage === 'de'
                ? s.speciality_name
                : t(`profession.speciality.${s.speciality_id}`),
            value: s.speciality_id,
          }
        }),
      }
      if (profId && p.profession_id === profId) {
        setSelectedProf(po)
      }
      profs.push(po)
    })

    profs.unshift({
      label: t<string>('core.no_specification'),
      value: null,
    })

    setProfessionOptions(profs)

    if (profId) {
    }

    const subscription = watch(async (value, { name, type }) => {
      // undefined is needed for phone adds
      if (type === 'change' && name === 'id_profession') {
        if (!value.id_profession) {
          setValue('id_speciality', null, { shouldDirty: true })

          setSelectedProf(null)
        } else {
          const tempProf = profs.filter((p) => p.value === value.id_profession)
          setSelectedProf({
            ...tempProf[0],
            specialities: tempProf[0]?.specialities
              ? [...tempProf[0].specialities]
              : [],
          })
        }
      }
    })
    return () => subscription.unsubscribe()
  }, [loadedBasicInformation])

  return (
    <>
      <div className={'col-12 md:col-3 ml-0 pl-0 field'}>
        <label
          htmlFor="profession"
          className={classNames({ 'p-error': errors.id_profession })}
        >
          {t<string>('apprentice.profession')}
        </label>
        <Controller
          name="id_profession"
          control={control}
          render={({ field }) => (
            <Dropdown
              options={professionOptions}
              value={field.value}
              filter={true}
              showFilterClear={true}
              defaultValue={null}
              optionValue={'value'}
              onChange={(e) => {
                field.onChange(e.value)
              }}
              placeholder={t<string>('core.select')}
            />
          )}
        />
      </div>

      <div className={'col-12 md:col-3 ml-0 pl-0 field'}>
        <label htmlFor="id_speciality">
          {t<string>('apprentice.speciality')}
        </label>

        <Controller
          name="id_speciality"
          control={control}
          render={({ field }) => (
            <Dropdown
              value={field.value}
              options={
                selectedProf?.specialities ? selectedProf.specialities : []
              }
              onChange={(e) => {
                field.onChange(e.value)
              }}
              placeholder={
                !selectedProf?.specialities ||
                selectedProf.specialities.length === 0
                  ? t<string>('core.not_available')
                  : t<string>('core.select')
              }
              // valueTemplate={(e) =>
              //   t<string>(`profession.speciality.${e?.id_speciality}`)
              // }
              disabled={
                !selectedProf?.specialities ||
                selectedProf.specialities.length === 0
              }
            />
          )}
        />
      </div>
    </>
  )
}